<template>
  <div v-if="isReady">
    <Panel :padding="[22, 24]">
      <div class="question-desc">
        <div>{{ currItem.question_description_obj[computedLang] }}</div>
        <div class="language-select-con" v-if="currItem.screen_text_trans">
          <!-- <p class="title">{{ $t('edit_message_language') }}</p> -->
          <el-select
            v-model="translationLanguage"
            size="small"
            @change="changeLanguage"
            class="language-select"
          >
            <el-option
              v-for="item in languageList"
              :key="item.value"
              :label="item.title"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <slot></slot>
      </div>

      <div class="panel-content">
        <div class="panel-article" v-if="currItem.screen_text">
          <div v-for="(screenText, index) in currItem.screen_text" :key="index + screenText.type">
            <img
              style="width: 500px"
              v-if="screenText.type == 'image'"
              :src="baseUrl + screenText.content + '?width=300'"
              alt=""
            />
            <p v-else-if="screenText.type == 'text'">{{ screenText.content }}</p>
          </div>
          <img
            v-if="currItem?.playStatus !== 'pause'"
            @click="clickPlayVoice(currItem)"
            :src="iconPlay('play')"
            alt=""
          />
          <img
            v-if="currItem?.playStatus === 'pause'"
            @click="clickPauseVoice()"
            :src="iconPlay('pause')"
            alt=""
          />
        </div>
        <div v-if="currItem.screen_text_trans" class="question-stem">
          <span class="question-index">{{ currItem.index }}.</span>
          <div v-html="translationStem"></div>
        </div>

        <div class="answer_result">
          <div class="answer_result-title">{{ $t('mark_answer') }}:</div>
          <div v-if="currItem.useAnswer">
            <RecordPlayer
              v-if="currItem.useAnswer"
              :soundUrl="currItem.useAnswer"
              :simpleType="false"
              :fatherPause="fatherPause"
            ></RecordPlayer>
          </div>
          <strong v-else>{{ $t('hsk_homework_no_answer') }}</strong>
        </div>
        <div class="reference_answer" v-if="currItem?.evaluate?.standard_answer">
          <div>{{ $t('hsk_reference_answer') }}</div>
          <p>{{ currItem.evaluate.standard_answer[0] }}</p>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
import { getAllWordsLength } from '@/utils/utils'
import RecordPlayer from './common/recordPlayer'
import { getLanguageSelectList, getScreenTextByLanguage } from '@/utils/hskTool'
export default {
  name: 'CommonSpeakingTyResult',
  props: {
    currItem: {
      type: Object,
      default: () => {},
    },
    baseUrl: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      translationLanguage: '',
      languageList: [],
      translationStem: '',
      fatherPause: false,
      icons: {
        play: require('@/assets/images/btn_play_hsk.png'),
        pause: require('@/assets/images/btn_pause_hsk.png'),
        playHsk: require('@/assets/images/play_hsk.png'),
      },
    }
  },
  watch: {
    currItem: {
      handler(val) {
        if (val.screen_text_trans) {
          // 如果是翻译，需要初始化多语言列表，展示对应的多语言题干
          this.languageList = getLanguageSelectList(val.screen_text_trans)
          this.translationLanguage =
            sessionStorage.getItem('translationLanguage') || this.languageList[0].value
          this.translationStem = getScreenTextByLanguage(
            val.screen_text_trans,
            this.translationLanguage
          )
        }
      },
      immediate: true,
    },
  },
  methods: {
    changeLanguage() {
      this.translationStem = getScreenTextByLanguage(
        this.currItem.screen_text_trans,
        this.translationLanguage
      )
      sessionStorage.setItem('translationLanguage', this.translationLanguage)
    },
    iconPlay(playType) {
      return this.icons[playType]
    },
    //点击播放小题题干
    clickPlayVoice(question) {
      //this.resetPlayStatus('pause')
      this.$emit('updatePlayStatus', question.index, 'pause')
      let audioPath = this.baseUrl + question.listen.audio_file
      console.log(audioPath, 'audioPath')
      this.$player.play(audioPath)
      this.$player.onended = () => {
        //this.resetPlayStatus('play')
        this.$emit('updatePlayStatus', question.index, 'play')
      }
    },
    //点击暂停
    clickPauseVoice() {
      this.$player.pause()
      this.$emit('updatePlayStatus', this.currItem.index, 'play')
      //this.resetPlayStatus('play')
    },
    //重置播放状态
    resetPlayStatus(status) {
      // eslint-disable-next-line vue/no-mutating-props
      this.currItem.playStatus = status
    },
  },
  computed: {
    isReady() {
      return JSON.stringify(this.currItem) !== '{}'
    },
    wordLength() {
      return getAllWordsLength(this.inputTitle) + getAllWordsLength(this.inputText)
    },
    computedLang() {
      return localStorage.getItem('language') || 'en'
    },
    // computedText() {
    //   return this.currItem?.screen_text.slice(1, this.currItem?.screen_text.length)
    // },
  },
  components: {
    RecordPlayer,
  },
}
</script>

<style lang="scss" scoped>
.question-desc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding-top: 10px;
  .language-select-con {
    position: absolute;
    top: 6px;
    right: 180px;
    width: 100px;
  }
}
.question-stem {
  margin-bottom: 20px;
  margin-top: 20px;
  display: flex;
  .question-index {
    color: #b5b5be;
    margin-right: 8px;
  }
}
.panel-content {
  margin-left: 32px;
  margin-top: 12px;
  .panel-article {
    p {
      text-indent: 2em;
      font-size: 14px;
      font-weight: 400;
      color: #393d46;
      line-height: 25px;
    }
  }
  .answer_result {
    &-title {
      color: #faae56;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      margin-top: 24px;
      margin-bottom: 8px;
    }
    p {
      font-weight: 600;
      font-size: 14px;
      color: #2c2f46;
      text-indent: 2em;
      line-height: 25px;
    }
    strong {
      font-weight: 600;
    }
    .limit {
      font-weight: 600;
      font-size: 14px;
      color: #2c2f46;
      margin-top: 10px;
      text-align: right;
    }
  }
  .reference_answer {
    margin-top: 24px;
    div {
      color: #faae56;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      margin-top: 24px;
      margin-bottom: 8px;
    }
    p {
      font-size: 14px;
      color: #545961;
      line-height: 25px;
      text-indent: 2em;
    }
  }
}
</style>
